// using ES6 modules
import lozad from 'lozad'

const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();


function initPage() {
    document.dispatchEvent(new Event('vitePageLoaded'));
}

if (window.addEventListener) {
    window.addEventListener('load', initPage, false);
} else if (window.attachEvent) {
    window.attachEvent('onload', initPage);
}
